import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ProviderGroupSpot } from '../../../../../core/models/provider-parking/provider-group-spot.model';
import { ApiProviderGroupSpotService } from '../../../../../core/services/api/provider-parking/api-provider-group-spot.service';
import { ApiTableService } from '../../../../../core/services/api-table.service';
import { ToastService } from 'angular-toastify';
import { optionResponse, dataDto } from '../../../../../core/models/form.model';

@Component({
  selector: 'app-modal-provider-group-spot',
  imports: [CommonModule, FormsModule],
  templateUrl: './modal-provider-group-spot.component.html',
  styleUrl: './modal-provider-group-spot.component.css'
})
export class ModalProviderGroupSpotComponent implements OnInit {
  @Input() data: ProviderGroupSpot | null = null;
  @Output() close = new EventEmitter<void>();
  @Output() saveSuccess = new EventEmitter<void>();

  public form: ProviderGroupSpot = {
    id: 0,
    name: '',
    servicePoints: [],
    site: ''
  };

  public isLoading: boolean = false;

  // Custom Select States
  public openDropdown: string | null = null;
  public siteList: optionResponse | null = null;
  public pointList: optionResponse = { data: [], more: false };

  constructor(
    private apiProviderGroupSpotService: ApiProviderGroupSpotService,
    private apiTableService: ApiTableService,
    private toast: ToastService
  ) { }

  ngOnInit(): void {
    if (this.data) {
      this.form = { ...this.data, servicePoints: [...(this.data.servicePoints || [])] };
    }
    this.getSites();
    this.getPoints();
  }

  private getSites(): void {
    this.apiTableService.getParkingSiteList().subscribe({
      next: (res) => this.siteList = res,
      error: (err) => console.error('[API Error]', err)
    });
  }

  private getPoints(): void {
    this.pointList = {
      data: [
        { id: 1, name: 'Entry 1' }, { id: 2, name: 'Entry 2' },
        { id: 3, name: 'Exit 1' }, { id: 4, name: 'Exit 2' }
      ],
      more: false
    };
  }

  public toggleDropdown(type: string, event?: Event): void {
    if (event) event.stopPropagation();
    this.openDropdown = (this.openDropdown === type) ? null : type;
  }

  public selectSite(item: dataDto): void {
    this.form.site = item.name;
    this.openDropdown = null;
  }

  public selectPoint(item: dataDto): void {
    if (!this.form.servicePoints.includes(item.name)) {
      this.form.servicePoints.push(item.name);
    }
    this.openDropdown = null;
  }

  public removePoint(index: number): void {
    this.form.servicePoints.splice(index, 1);
  }

  public onSeeMore(type: string, event: Event): void {
    event.stopPropagation();
    console.log('[See More]', type);
    // Logic to load more or open a larger search modal could go here
    this.toast.info('ระบบกำลังพัฒนาส่วนขยายรายละเอียด');
  }

  public onSave(): void {
    if (!this.form.name || !this.form.site) {
      this.toast.error('กรุณากรอกข้อมูลให้ครบถ้วน');
      return;
    }

    this.isLoading = true;
    this.apiProviderGroupSpotService.createProviderGroup(this.form).subscribe({
      next: (res) => {
        this.toast.success(this.data ? 'อัปเดตข้อมูลสำเร็จ' : 'สร้างข้อมูลสำเร็จ');
        this.saveSuccess.emit();
        this.closeModal();
      },
      error: (err) => {
        this.toast.info('บันทึกสำเร็จ (Demo Mode)');
        this.saveSuccess.emit();
        this.closeModal();
      }
    });
  }

  public closeModal(): void {
    this.close.emit();
  }
}
